<template>
  <div>
    <div v-if="!isMobile" class="bg-primary flex flex-col justify-between h-full w-270 text-app-color ">
      <div class="w-full mx-auto pt-67 pl-30 overflow-y-auto">
        <h2 class="pl-20 mb-30 font-bold text-37">Templates</h2>

        <p
          class="pl-20 py-8 leading-small cursor-pointer rounded-4"
          :class="[
            activeState === 'All' ? activeClass : '',
            isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
          ]"
          @click="update('All')"
        >
          All templates
        </p>
        <p
          class="pl-20 py-8 leading-small cursor-pointer rounded-4"
          :class="[
            activeState === 'Library' ? activeClass : '',
            isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
          ]"
          @click="update('Library')"
        >
          Templates library
        </p>
        <p
          v-if="isTeamAccount"
          class="pl-20 py-8 leading-small cursor-pointer rounded-4"
          :class="[
            activeState === 'Private' ? activeClass : '',
            isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
          ]"
          @click="update('Private')"
        >
          My templates
        </p>
        <p
          v-if="isTeamAccount"
          class="pl-20 py-8 leading-small cursor-pointer rounded-4"
          :class="[
            activeState === 'Shared' ? activeClass : '',
            isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
          ]"
          @click="update('Shared')"
        >
          Shared templates
        </p>
      </div>
    </div>

    <div v-if="isMobile && showAside" class="bg-primary flex flex-col justify-between h-full w-full text-app-color ">
      <div class="w-full pt-30 pb-50 max-w-320 mx-auto overflow-y-auto">
        <h2 class="pl-20 mb-30 font-bold text-24">Templates</h2>
        <div
          class="menu-item hover:bg-hover rounded-10 px-20"
          :class="isDarkMode ? 'bg-sidebar' : 'bg-grey-450'"
          @click="updateMobile('All')"
        >
          <p>All templates</p>
          <i class="text-14 icon-keyboard-arrow-left transform rotate-180 opacity-50" />
        </div>

        <div
          class="menu-item hover:bg-hover rounded-10 px-20"
          :class="isDarkMode ? 'bg-sidebar' : 'bg-grey-450'"
          @click="updateMobile('Library')"
        >
          <p>Templates library</p>
          <i class="text-14 icon-keyboard-arrow-left transform rotate-180 opacity-50" />
        </div>

        <div
          v-if="isTeamAccount"
          class="menu-item hover:bg-hover rounded-10 px-20 mt-20"
          :class="isDarkMode ? 'bg-sidebar' : 'bg-grey-450'"
          @click="updateMobile('Private')"
        >
          <p>My templates</p>
          <i class="text-14 icon-keyboard-arrow-left transform rotate-180 opacity-50" />
        </div>

        <div
          v-if="isTeamAccount"
          class="menu-item hover:bg-hover rounded-10 px-20 mt-20"
          :class="isDarkMode ? 'bg-sidebar' : 'bg-grey-450'"
          @click="updateMobile('Shared')"
        >
          <p>Shared templates</p>
          <i class="text-14 icon-keyboard-arrow-left transform rotate-180 opacity-50" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  emits: ['toggle'],

  setup (_, { emit }) {
    const { state, getters, commit } = useStore()

    const activeState = computed(() => state.template.activeState)
    const showAside = computed(() => state.template.showAside)
    const isDarkMode = computed(() => getters.isDarkMode)
    const isMobile = computed(() => getters.isMobile)
    const isTeamAccount = computed(() => getters.isTeamAccount)

    const activeClass = computed(() => {
      return isDarkMode.value ? 'font-semibold bg-hover' : 'font-semibold bg-grey-450'
    })

    function update (value) {
      commit('changeTemplateState', value)
    }

    function updateMobile (value) {
      commit('changeTemplateState', value)
      emit('toggle')
    }

    return {
      activeState,
      showAside,
      isDarkMode,
      isMobile,
      activeClass,
      isTeamAccount,
      update,
      updateMobile
    }
  }
})
</script>
